/**
 * Sentinel option id used in the class/event wizard's form dropdown to mean
 * "use a custom external link" instead of an in-app pre-reservation form.
 * It is a UI-only value: on save it is translated back to a null
 * preReservationFormId (the external link lives in formCompletionLink).
 */
export const CUSTOM_FORM_LINK_OPTION_ID = -1;
